import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import TextLink from 'LuxKit/TextLink'
import tripPlannerGlossaryMessages from 'tripPlanner/i18n/tripPlannerGlossaryMessages'

interface Props {
  expanded: boolean
  /** Id of the list this link expands and collapses. */
  controlsId: string
  collapsedLabel: string
  onClick: () => void
}

function ChatListShowMoreToggle({ expanded, controlsId, collapsedLabel, onClick }: Props) {
  const icon = useMemo(() => <DropdownChevron open={expanded} />, [expanded])

  return (
    <TextLink
      size="medium"
      weight="regular"
      colour="normal-contrast"
      endIcon={icon}
      aria-expanded={expanded}
      aria-controls={controlsId}
      onClick={onClick}
    >
      {expanded && <FormattedMessage {...tripPlannerGlossaryMessages.showLess} />}
      {!expanded && collapsedLabel}
    </TextLink>
  )
}

export default ChatListShowMoreToggle
